import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";

import { registerNavEntry, registerNavSection } from "./shell/navigation";

registerNavSection({ key: "work", spoke: "workflow", title: "My work", icon: AutoAwesomeIcon, order: 5, entries: [
  { label: "Approvals", to: "/app/approvals" },
  { label: "Reminders & tasks", to: "/app/reminders" },
  { label: "Notifications", to: "/app/notifications" },
] });
registerNavEntry("settings", { label: "Automation", to: "/app/settings/automation", permission: "workflow.automation.view" });
registerNavEntry("settings", { label: "Scheduled jobs", to: "/app/settings/jobs", permission: "workflow.automation.view" });
